import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Selector } from "../../components/common";
import { validator } from "../../helpers/validation";
import {
  addExpenses,
  fetchAllCategoriesss,
  fetchAllDriver,
  fetchAllSorterDriver,
  uploadDriverDocument,
} from "../../actions";
import { categoryData, status } from "../../constants/expenses";
import { driverName } from "../../constants/driver";
import { NotificationManager } from "react-notifications";
import { Formik, Form, useFormik } from "formik";
import ViewDatePicker from "../../components/common/datePicker";
import { fixedValue } from "../../components/common/round";
import * as Yup from "yup";
import { FormEvent } from "react";
import Loader from "../../components/common/loader";
import InputSelect from "../../components/common/InputSelect";

const initialState = {
  date: "",
  category: "",
  amount: "",
  status: "",
  driver: "",
  description: "",
  receiptDocuments: [],
};

function Edit() {
  const receiptDocument = useRef(null);
  const [Document, setDocument] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [amt, setAmt] = useState(0);
  // const {category, loader} = useSelector(({expenses})=>expenses)
  const { options, loader } = useSelector(({ category }) => category);
  // console.log("category>>", options);
  // const { drivers } = useSelector(({ driver }) => driver);
  // const { rows: data } = drivers;
  const { sorterDrivers } = useSelector(({ driver }) => driver);
  const { rows: data } = sorterDrivers;

  useEffect(() => {
    // dispatch(fetchAllDriver());
    dispatch(fetchAllSorterDriver())
    dispatch(fetchAllCategoriesss());
  }, []);

  const FormValidation = Yup.object({
    date: Yup.date().required("Required"),
    description: Yup.string().required("Required"),
    category: Yup.string().required("Required"),
    amount: Yup.number().typeError("must be a number").required("Required"),
    status: Yup.string().required("Required"),
    driver: Yup.string().required("Required"),
  });

  //   const handleOnChange = (event: FormEvent) => {
  //     const {name} = event.target
  //     if(name === "amount"){
  //       let num = event.target.value
  //       if(num.includes(".") && num.split(".")[1].length>2) return;
  //       setAmt(num)
  //     }
  // };
  const handleSubmit = (values, { resetForm }) => {
    const expenses = {
      amount: values.amount,
      category: +values?.category,
      date: values.date,
      description: values.description,
      status: values.status,
      driver_id: values.driver,
      receiptDocuments: values.receiptDocuments,
    };
    dispatch(addExpenses(expenses, navigate));
    // resetForm({values: ""})
  };

  const handleDocuments = async (setFieldValue, values) => {
    const data = new FormData();
    data.append("file", Document);
    const response = await uploadDriverDocument(data);
    setFieldValue("receiptDocuments", [...values.receiptDocuments, response]);
    setDocument("");
  };

  const handleChangeDocument = async (e, ind, setFieldValue, values) => {
    e.preventDefault();
    const data = new FormData();
    data.append("file", e.target.files[0]);
    const response = await uploadDriverDocument(data);
    const updateData = values.receiptDocuments.map((ele, ind1) =>
      ind1 == ind ? response : ele
    );
    setFieldValue("receiptDocuments", updateData);
  };

  const handleDeleteDocument = (ind, setFieldValue, values) => {
    const updateData =
      values.receiptDocuments?.length &&
      values.receiptDocuments.filter((ele, ind1) => ind1 != ind);
    setFieldValue("receiptDocuments", updateData);
  };

  const handleDriverDocumentClick = () => {
    receiptDocument.current.click();
  };

  return (
    <div id="kt_app_content" className="app-content flex-column-fluid">
      <div
        id="kt_app_content_container"
        className="app-container container-xxl"
        style={{ padding: "0px !important" }}
      >
        <div className="card mb-5 mb-xl-10">
          <div
            className="card-header border-0 cursor-pointer"
            role="button"
            data-bs-toggle="collapse"
            data-bs-target="#kt_account_profile_details"
            aria-expanded="true"
            aria-controls="kt_account_profile_details"
            style={{ padding: 0 }}
          >
            <div className="card-title m-0">
              <h3 className="fw-bold m-0">Add Expense</h3>
            </div>
          </div>
          <div
            id="kt_account_settings_profile_details"
            className="collapse show"
          >
            <Formik
              initialValues={initialState}
              validationSchema={FormValidation}
              onSubmit={handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                resetForm,
                handleBlur,
                setFieldValue,
              }) => (
                <Form id="kt_account_profile_details_form" className="form">
                  <div className="card-body border-top p-9">
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Date
                      </label>
                      <div className="col-lg-8 fv-row">
                        <ViewDatePicker
                          className="form-control form-control-lg form-control-solid"
                          type="text"
                          id="date"
                          name="date"
                          onChange={(value) =>
                            setFieldValue("date", value.toISOString())
                          }
                          value={values.date}
                          onBlur={handleBlur}
                          style={{ paddingLeft: 10 }}
                        />
                        <div className="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.date && errors.date ? errors.date : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Category
                      </label>
                      <div className="col-lg-8 fv-row">
                        <Selector2
                          name="category"
                          style={{ height: "50px" }}
                          data={options.map((it) => {
                            return { value: it.id, title: it.category };
                          })}
                          onChange={(value) => setFieldValue("category", value)}
                          value={values.category}
                          onBlur={handleBlur}
                        />
                        <div class="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.category && errors.category
                              ? errors.category
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Amount
                      </label>
                      <div className="col-lg-8 fv-row">
                        <input
                          type="number"
                          name="amount"
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Enter Amount"
                          onChange={handleChange}
                          value={values.amount}
                          onBlur={handleBlur}
                        />
                        <div class="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.amount && errors.amount
                              ? errors.amount
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Status
                      </label>
                      <div className="col-lg-8 fv-row">
                        <Selector2
                          name="status"
                          style={{ height: "50px" }}
                          data={status.map((it) => {
                            return { it: it, title: it };
                          })}
                          value={values.status}
                          onBlur={handleBlur}
                          onChange={(value) => {
                            setFieldValue("status", value);
                          }}
                        />
                        <div class="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.status && errors.status
                              ? errors.status
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Driver
                      </label>
                      <div className="col-lg-8 fv-row" style={{position:'relative'}}>
                        <InputSelect
                        name="driver"
                        data={
                        data.length
                          ? data.map((it) => {
                              return {
                                value: it.id,
                                title: `${it.firstName} ${it.lastName}`,
                                status:it?.driverType
                              };
                            })
                          : ["Loadin..."]
                        }
                        onChange={(value) => setFieldValue("driver", value)}
                        value ={values.driver}
                        />
                        <div class="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.driver && errors.driver
                              ? errors.driver
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Description
                      </label>
                      <div className="col-lg-8 fv-row">
                        <input
                          type="text"
                          name="description"
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Enter Description"
                          onChange={handleChange}
                          value={values.description}
                          onBlur={handleBlur}
                        />
                        <div class="fv-plugins-message-container invalid-feedback">
                          <div data-field="fname" data-validator="notEmpty">
                            {touched.description && errors.description
                              ? errors.description
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-6">
                      <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                        Receipt Documents
                      </label>
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="col-lg-9 fv-row">
                            <input
                              name="driverDocuments"
                              type="text"
                              value={
                                Document && Document.name
                                  ? Document?.name
                                  : "Select File"
                              }
                              className="form-control form-control-lg form-control-solid"
                              placeholder="select driver document"
                              onClick={handleDriverDocumentClick}
                            />

                            <input
                              style={{ display: "none" }}
                              name="driverDocuments"
                              type="file"
                              className="form-control form-control-lg form-control-solid"
                              placeholder="Scanner User Name"
                              onChange={(e) => setDocument(e.target.files[0])}
                              onBlur={handleBlur}
                              ref={receiptDocument}
                            />
                            <div class="fv-plugins-message-container invalid-feedback">
                              <div data-field="fname" data-validator="notEmpty">
                                {touched.receiptDocuments &&
                                errors.receiptDocuments ? (
                                  <div>{errors.receiptDocuments}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-lg fv-row">
                            <button
                              type="button"
                              onClick={() =>
                                handleDocuments(setFieldValue, values)
                              }
                              className="btn btn-primary"
                              style={{ width: "100%" }}
                              disabled={Document !== "" ? false : true}
                            >
                              Add Document
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {values.receiptDocuments.length ? (
                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                          Selected Files
                        </label>
                        <div className="col-lg-8 d-flex flex-wrap justify-content-start">
                          {values.receiptDocuments
                            ? values.receiptDocuments.map((ele, ind) => (
                                <div
                                  className="col-lg-3"
                                  style={{ margin: "20px 10px" }}
                                >
                                  {/*begin::Image input*/}
                                  <div className="image-input image-input-outline">
                                    {/*begin::Preview existing avatar*/}
                                    <div
                                      className="image-input-wrapper w-125px h-125px"
                                      style={{
                                        backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL_IMAGE}${ele})`,
                                      }}
                                    />
                                    {/*end::Preview existing avatar*/}
                                    {/*begin::Label*/}
                                    <label
                                      className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                      data-kt-image-input-action="change"
                                      data-bs-toggle="tooltip"
                                      title="Change avatar"
                                    >
                                      <i className="bi bi-pencil-fill fs-7" />
                                      {/*begin::Inputs*/}
                                      <input
                                        type="file"
                                        name="avatar"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={(e) =>
                                          handleChangeDocument(e, ind,setFieldValue, values)
                                        }
                                      />
                                      <input
                                        type="hidden"
                                        name="avatar_remove"
                                      />
                                      {/*end::Inputs*/}
                                    </label>
                                    <span
                                      className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                      data-kt-image-input-action="remove"
                                      data-bs-toggle="tooltip"
                                      title="Remove avatar"
                                      onClick={() => handleDeleteDocument(ind,setFieldValue, values)}
                                    >
                                      <i className="bi bi-x fs-2" />
                                    </span>
                                    {/*end::Remove*/}
                                  </div>
                                  {/*end::Image input*/}
                                  {/*end::Col*/}
                                </div>
                              ))
                            : "No Result Found!"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {/* </div> */}
                  <div className="card-footer d-flex justify-content-end py-6 px-9">
                    <button
                      type="reset"
                      className="btn btn-light btn-active-light-primary me-2"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      name="description"
                      disabled={loader}
                      className="btn btn-primary"
                      id="kt_account_profile_details_submit"
                      // onClick={handleSubmit}
                    >
                      {loader ? <Loader size={17} /> : "Add Expenses"}
                    </button>
                    <button
                      type="reset"
                      className="btn btn-primary"
                      id="kt_account_profile_details_submit"
                      style={{ marginLeft: 10 }}
                      onClick={() =>
                        resetForm({
                          date: "",
                          category: "",
                          amount: "",
                          status: "",
                          driver: "",
                          description: "",
                        })
                      }
                    >
                      <i
                        class="bi bi-arrow-repeat"
                        style={{ fontSize: 25 }}
                      ></i>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit;

const styles = {
  backgroundColor: "#f5f8fa",
  width: "100%",
  height: "100%",
  padding: "10px 20px",
  border: "none",
  outline: "none",
  borderRadius: "20px",
};

function Selector2({
  name = "",
  data = [],
  style = {},
  onChange = () => {},
  value = "",
}) {
  const [type, setType] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setType(value);
    onChange(value);
  };

  //option attributes --> hidden,disabled
  return (
    <select
      name={name}
      id="cars"
      data-control="select2"
      className="form-select form-select-solid"
      style={{ ...styles, ...style }}
      onChange={handleChange}
    >
      <option
        className="col-lg-8 fv-row fw-semibold fs-6"
        selected={value === ""}
        value=""
      >
        {" "}
        choose one{" "}
      </option>
      {data?.length &&
        data.map((op, index) => (
          <option
            className="col-lg-8 fv-row fw-semibold fs-6"
            selected={value === op.value}
            key={index}
            value={op.value}
          >
            {op.title}
          </option>
        ))}
    </select>
  );
}
